import { Grid } from "@mui/material";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { callAPI, IsSmallScreen, Method, updateMainHeader } from "../../commonFunctions/CommonFunctions";
import http from "../../commonFunctions/httpClient";
import PermissionDenied from "../../commonFunctions/PermissionDenied";
import { AllPermissions } from "../../commonFunctions/PermissionManger";
import { breadCrumbsStore } from "../../Components/BreadCrumbs/BreadCrumbsListner";
import WSDataGrid, { IColumns } from "../../Components/DataGrid/WSDataGrid";
import WSMobileDataGridAdvanced, { IOrderColumns } from "../../Components/DataGrid/WSMobileDataGridAdvanced";
import { openPopUp } from "../../Components/Dialog/OpenNewModal";
import { IMetaData } from "../../Components/Dialog/WSCommonDialog";
import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";
import { resetDataComponent } from "../../StateManagement/actions";
import { UpdateStatus } from "../Masters/Lead/UpdateStatus";
import ConfirmDialog, { useConfirmDialog } from "../../Components/Confirmation/ConfirmDialog";

export const ContactList: React.FC<any> = React.memo((props) => {

    const navigate = useNavigate();
    const isMobile = IsSmallScreen();
    const { showMessage } = useSnackbar();
    const dispatch = useDispatch();
    AllPermissions.getInstance();
    const location = useLocation();
    const { status } = location.state || {};
    const { add, edit, remove, view } = AllPermissions.getContactPermission;
    const {
        open,
        title,
        onConfirm,
        handleClose,
        openConfirmDialog,
    } = useConfirmDialog();
    useEffect(() => {
        updateMainHeader("Contacts");
        breadCrumbsStore.updateBreadCrumbs([
            { "Contacts": "contacts/list" },

        ]);
    });
    const source = {
        url: "leads/search",
        page: 1,
        pageSize: 10,
        filter: [
            {
                field: "leadType",
                operator: "eq",
                value: "1"
            },
            ...(status ? [status] : []) // ✅ only include if status exists
        ],
        sort: [
            {
                field: "UptedAt", // maybe typo? was "UptedAt"
                direction: "desc"
            }
        ],
    };
    const saveStatusData = async (data: any) => {
        const request: any = {

            leadId: data?.leadId,
            status: data?.newStatus,
            statusDetails: "Status Updated"


        };

        const response: any = await callAPI(`lead-status`, Method.PUT, request, data?.leadId);
        return response;
    };
    const handleStatusChange = async (data: any) => {
        try {
            // setLoading(true);
            const response: any = await saveData(data);
            if (response && response.message) {
                dispatch(resetDataComponent("contactGrid"));
                showMessage(
                    response.message || "Status updated successfully!",
                    "success"
                );
            }
        } catch (e: any) {
            showMessage(e.error, "error");
        }
    };
    const handleDelete = async (id?: string | number) => {
        const response: any = await callAPI(`leads`, Method.DELETE, null, id);
        dispatch(resetDataComponent('contactGrid'));
        if (response?.success) {
            showMessage(response?.message, "success")
        }
        else {
            showMessage(response?.message || 'Something went wrong', "error")
        }
        handleClose()

    };
    /**
     * Edit function
     * @param action 
     * @param row 
     */
    const handleAction = async (action: string, row: any) => {
        if (action === "View") {
            navigate(`/contact/edit/${row?.id}`)
        }
        else if (action === "Delete") {
            openConfirmDialog("Delete this record?", () => handleDelete(row?.id))
        }

        else if (action === 'Site Visit') {
            await handleStatus(row);
            await submitSiteVisitNotifications(row);
        } else if (action === "Change Status") {
            const metadataStatus: IMetaData = {
                title: "Update Status",
                hideActions: false,
                content: (props: any, rows: any) => <UpdateStatus {...props} contact={true} rowId={row?.id} />,
                actions: [
                    {
                        label: "Cancel",
                        className: "ws-cancel",
                        type: "button"
                    },
                    {
                        label: "Submit",
                        onClick: handleStatusChange,
                        type: "submit",
                        autoFocus: true
                    }
                ],
                isDragable: true
            };
            openPopUp(metadataStatus, handleStatusChange, "40rem");
        }
    };
    const saveData = async (data: any) => {
        const request: any = {
            leadId: data?.leadId || data?.id,
            status: data?.newStatus,
            statusDetails: "Status Updated"
        };

        const response: any = await callAPI(`lead-status`, Method.PUT, request, data?.leadId || data?.id);

        return response;
    };
    const saveDataSiteVisit = async (data: any) => {
        const request: any = {
            leadId: data?.leadId || data?.id,
            status: 'Site Visit',
            statusDetails: "Status Updated"
        };

        const response: any = await callAPI(`lead-status`, Method.PUT, request, data?.leadId || data?.id);

        return response;
    };
    const handleStatus = async (row: any) => {
        try {
            // setLoading(true);

            const response: any = await saveDataSiteVisit(row);
            if (response && response.message) {
                dispatch(resetDataComponent("contactGrid"));
                showMessage(
                    response.message || "Status updated successfully!",
                    "success"
                );
            }
        } catch (e: any) {
            showMessage(e.error, "error");
        }
    }
    const submitSiteVisitNotifications = async (row: any) => {
        try {

            const response: any = await http.post(`leads/notify/pincode/${row.zipCode}/${row?.id}`, {});
            if (response) {
                showMessage(response?.message || response, response?.success ? 'success' : 'error')
            }

        } catch (error) {

        }

    }

    const columns: IColumns[] = [
        {
            header: "Company",
            fieldName: "company",
            type: "default",
        },
        {
            header: "Full Name",
            fieldName: "fullName",
            type: "default",
        },
        {
            header: "Email",
            fieldName: "email",
            tooltip: true,
            isHide: isMobile ? true : false,
            type: "default",
        },
        {
            header: "Mobile",
            fieldName: "mobile",
            tooltip: true,
            isHide: isMobile ? true : false,
            type: "default",
        },
        {
            header: "status",
            fieldName: "status",
            tooltip: true,
            type: "status"
        },
        {
            header: "Actions",
            fieldName: "actions",
            type: "action",
            actions: [edit ? "View" : undefined, "Site Visit", "Change Status", remove ? "Delete" : undefined].filter(Boolean),
            actionCallback: (action, row) => handleAction(action, row),
            fieldCompare: { fieldName: 'leadType', ValueCheck: { value: 1, actionCheck: "Convert to Contact" } },
            hideSelectedActions: {
                // fieldToShow: [
                //     {
                //         field: "status",
                //         showActions: ["View"],
                //         showValue: ['ReportSubmitted']
                //     },

                // ],
                fieldToHide: [
                    {
                        field: "status",
                        hideActions: ["Site Visit", "Change Status"],
                        hideValue: ['Site Visit', 'Task Assigned', 'Change Status', 'ReportSubmitted', 'Survey Accepted']
                    },
                    {
                        field: "status",
                        hideActions: ["Change Status"],
                        hideValue: ['Site Visit', 'Task Assigned']
                    },
                ],
            }
        }


    ];
    const mobColumns: IOrderColumns[] = [

        {
            header: "Full Name",
            fieldName: "fullName",
            labelSx: { fontWeight: 'bold' },
            type: "default",
            sm: 6,
            // otherFiels:[{fieldName:'email' ,type:'default'}]
            //  sortable: true
        },
        {
            header: "Email",
            fieldName: "email",
            tooltip: true,
            type: "default",
            sm: 6
        },
        {
            header: "Company",
            fieldName: "company",
            type: "default",
            sm: 6
        },

        {
            header: "Mobile",
            fieldName: "mobile",
            tooltip: true,
            sm: 6,
            type: "default",
        },

        {
            header: "Created On",
            fieldName: "createdAt",
            sm: 4,
            isBoderRadious: true,
            type: "date",
        },
        {
            header: "Updated On",
            fieldName: "uptAt",
            sm: 4,
            isBoderRadious: true,
            type: "date",
        },
        {
            header: "Actions",
            fieldName: "actions",
            type: "action",
            sm: 4,
            actions: [edit ? "View" : undefined].filter(Boolean),
            actionCallback: (action, row) => handleAction(action, row),

        },

    ];
    const handleClick = () => {
        navigate('/contact/create')
    }
    const transFormData = (data: any) => {
        if (data) {
            data.map((item: any) => {
                item.fullName = `${item?.firstName} ${item?.lastName ? item?.lastName : ''}`;
            })
            return data
        }
    }

    return (
        <>
            <Grid container spacing={2}>
                {view ? <Grid item xs={12}>
                    {!isMobile && <WSDataGrid
                        id="contactGrid"
                        title="Contacts"
                        columns={columns}
                        transFormData={transFormData}
                        source={source}
                        addButton={add ? { label: "New", color: "secondary" } : undefined}
                        onAddButtonClick={handleClick}
                        searchBox={{ fieldName: 'firstName,company,lastName,mobile' }}


                        gridHeaderSx={{ backgroundColor: 'whitesmoke', border: '1px solid whitesmoke' }}
                    />}
                    {
                        isMobile &&
                        <WSMobileDataGridAdvanced transFormData={transFormData} title={'Contacts'} addButton={{ label: 'New', color: 'secondary', }}
                            onAddButtonClick={handleClick} columns={mobColumns} id="contactGrid" source={source} />
                    }
                </Grid>
                    : <PermissionDenied />}
                <ConfirmDialog
                    open={open}
                    title={title}
                    onConfirm={onConfirm}
                    onClose={handleClose}
                />
            </Grid>
        </>
    )
})